import React, { Component } from 'react';
//import { Link } from 'react-router-dom';

import Web3 from 'web3';
import Dapp from './Dapp';
import About from './About';
import Scene from './Scene';

//import download from './img/download.png';
import snake from './img/infinity.gif';
import eth from './img/eth.png';

import './css/App.css';



class App extends Component {
  constructor(props) {
    super(props);

    const original = 'Save uncensorable text to the Ethereum blockchain. Forever.';
    this.state = {
      init: original,
      text: original,
      loading: true,
      web3: null,
      continue: false,
      getStarted: ""
    };

    this.interval = null;
    this.textInterval = null;

    this.charCount = 0;
  }

  componentDidMount() {
    //let s = this._randomString(this.state.init);
    //this.setState({text: s});
    this.interval = setInterval(()=>{
      this._checkLogin();
    }, 100);
/*
    this.textInterval = setInterval(()=>{
      if(this.charCount === this.state.init.length) {
        clearInterval(this.textInterval);
      } else {
        let c = this.state.init[this.charCount];
        let text = this.state.text.substr(0, this.charCount) + c + this.state.text.substr(this.charCount + 1);
        this.setState({text: text});
      }

      this.charCount++;
    }, 50);*/
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      this.state.web3 && this.state.continue ?
        <Dapp web3={this.state.web3} close={this._close.bind(this)} />
      :
        this.state.loading ?
          <div className="no-meta flex">
            <img className="snake" src={snake} alt="Forever" />
          </div>
        :
          <div className="no-meta home">
            <About />

            <Scene pause={this.state.continue} />
            <img className="eth" src={eth} alt="Ethereum" />
            <div className="inner flexv">
              <div>
              <h1><span>0xINFINITY</span></h1>
              <p className="big">{this.state.text}</p>

              {this.state.web3 ?
                <p className="install"><button onClick={this._continue.bind(this)}>Get Started{this.state.getStarted}</button></p>
                :
                <p className="install">Install and log into your <a href="https://metamask.io" target="_blank" rel="noopener noreferrer">MetaMask</a> or <a href="https://wallet.coinbase.com/" target="_blank" rel="noopener noreferrer">Coinbase Wallet</a> to post.</p>
              }
              {/*<a href="https://metamask.io" target="_blank" rel="noopener noreferrer" className="download-btn"><img src={download} alt="Download MetaMask" /></a>*/}
             </div>
            </div>
          </div>
    );
  }

  _close() {
    this.setState({continue: false});
  }

  _continue() {
    this.setState({continue: true});
  }

  _checkLogin() {
    var self = this;

    if(window.web3) {
      let web3 = new Web3(window.web3.currentProvider);
      web3.eth.getAccounts((error, accounts) => {
        if (accounts.length === 0) {
          // there is no active accounts in MetaMask
          self.setState({loading: false});
        }
        else {
          // It's ok
          //console.log(accounts);
          clearInterval(self.interval);
          self.setState({web3: web3, loading: false});
          self.interval = setInterval(()=>{
            switch(self.state.getStarted) {
              default:
              case "":
                self.setState({getStarted: "."});
              break;
              case ".":
                self.setState({getStarted: ".."});
              break;
              case "..":
                self.setState({getStarted: "..."});
              break;
              case "...":
                self.setState({getStarted: ""});
              break;
            }

          }, 500);
        }
      });

      self.setState({loading: false});
    } else {
      self.setState({loading: false});
    }
  }

  _randomString(original) {
    var text = original;
    var possible = "ABCDEF0123456789";

    for (var i = 0; i < text.length; i++) {
      if(text[i] !== ' ') {
        let c = possible.charAt(Math.floor(Math.random() * possible.length));
        text = text.substr(0, i) + c + text.substr(i + 1);
      }
    }


    return text;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js